const dev = {
  API_ENDPOINT_URL: "/backend/endpoints",
}
const prod = {
  API_ENDPOINT_URL: "https://api.pannello.solitonutrizione.it/endpoints",
};

const test = {
  API_ENDPOINT_URL: "https://api.pannello.solitonutrizione.it/endpoints",
};

const getEnv = () => {
  return dev;
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
